export default __webpack_public_path__ + "locales/sr-Latn-RS/SingleSignOn.json?hash=e5eb12d3922cb970f4d0cb0cba1c25f6";